import { clsx } from 'clsx';
import BaseModal, { BaseModalProps } from './BaseModal/BaseModal';

export function Modal({ contentClassName, children, ...rest }: BaseModalProps) {
  return (
    <BaseModal {...rest} contentClassName={clsx('dialog-content', contentClassName)}>
      {children}
    </BaseModal>
  );
}
